import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3733edf9 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _070680b1 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _2dc1ead4 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _a0b1966c = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _61f71d2c = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _be533668 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _1d26408a = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _a2478236 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _bbff20a4 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _6afea74f = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _bb5c463a = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _a7bbb3e6 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _7351a313 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _3974096a = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _34cc7c62 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _14bc3fcd = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _2d9ac774 = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _6a29eaaa = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _46141871 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _475767d1 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _a51a7558 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _54302f08 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _b605ec88 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _0f3b3f31 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _6545ffb7 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _5786c5ce = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _fde610e0 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _07bbe8b2 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _1da93d90 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _a6557150 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _45ee3d8f = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _6a6b9f9e = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _2fb042eb = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _45e9e223 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _3b9d9b25 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _154f939f = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _2f66020c = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _252bc1c4 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _d2e5dd0c = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _247d4f36 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _1c348194 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _10093442 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _3f88f43d = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _1f899390 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _6bc17cda = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _f2ecac42 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _05f0af89 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _b2b93fba = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _593c762a = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _47f17ae9 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _0e661330 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _6ba53610 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _c4a33a32 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _69427759 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _f66026e8 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _f7672d1e = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _2d68c552 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _7527ed66 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _6cf69438 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _0993783a = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _49c1e2c7 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _bb9f20cc = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _e48ff7da = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _f47fdd6a = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _11bb103c = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _d6b1cabe = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _58b4923c = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _d3832b74 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _0cf3c652 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _10a28596 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _2d67bc0b = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _c0100efa = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _301e14d2 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _9a1c1576 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _300fdd5a = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _562c47b5 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _3733edf9,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _070680b1,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _2dc1ead4,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _a0b1966c,
    name: "calendar"
  }, {
    path: "/customer",
    component: _61f71d2c,
    name: "customer"
  }, {
    path: "/details",
    component: _be533668,
    name: "details"
  }, {
    path: "/goals",
    component: _1d26408a,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _a2478236,
    name: "maisoku"
  }, {
    path: "/media",
    component: _bbff20a4,
    name: "media"
  }, {
    path: "/privacy",
    component: _6afea74f,
    name: "privacy"
  }, {
    path: "/project",
    component: _bb5c463a,
    name: "project"
  }, {
    path: "/response",
    component: _a7bbb3e6,
    name: "response"
  }, {
    path: "/sale",
    component: _7351a313,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _3974096a,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _34cc7c62,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _14bc3fcd,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _2d9ac774,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _6a29eaaa,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _46141871,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _475767d1,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _a51a7558,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _54302f08,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _b605ec88,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _0f3b3f31,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _6545ffb7,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _5786c5ce,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _fde610e0,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _07bbe8b2,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _1da93d90,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _a6557150,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _45ee3d8f,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _6a6b9f9e,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _2fb042eb,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _45e9e223,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _3b9d9b25,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _154f939f,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _2f66020c,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _252bc1c4,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _d2e5dd0c,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _247d4f36,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _1c348194,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _10093442,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _3f88f43d,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _1f899390,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _6bc17cda,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _f2ecac42,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _05f0af89,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _b2b93fba,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _593c762a,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _47f17ae9,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _0e661330,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _6ba53610,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _c4a33a32,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _69427759,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _f66026e8,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _f7672d1e,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _2d68c552,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _7527ed66,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _6cf69438,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _0993783a,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _49c1e2c7,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _bb9f20cc,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _e48ff7da,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _f47fdd6a,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _11bb103c,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _d6b1cabe,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _58b4923c,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _d3832b74,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _0cf3c652,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _10a28596,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _2d67bc0b,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _c0100efa,
    name: "property-property",
    children: [{
      path: "contact",
      component: _301e14d2,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _9a1c1576,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _300fdd5a,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _562c47b5,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
